import { useState, useEffect } from 'react';
import { NewApplicationStatus } from '../../../hoc/new-application/types';
import StepTwoValue from './step-two-values';
import { CorporateApplicationStepTwoTypes, StepTwoItemProps } from '../types';
import StepPartBlock from './parts/step-part-block';

import cn from '../new-application.module.css';

const NewApplicationCorporateInfoStepTwo = ({
  suppliers,
  customers,
  setValue,
  status,
  isEditable,
  errors,
  clearErrors,
  applicationScheme,
}: CorporateApplicationStepTwoTypes) => {
  const [suppliersList, setSuppliersList] = useState<StepTwoItemProps[]>([
    { id: 'supplier-id-0', name: '', monthlyTurnoverRangeId: '' },
  ]);
  const [customersList, setCustomersList] = useState<StepTwoItemProps[]>([
    { id: 'customer-id-0', name: '', monthlyTurnoverRangeId: '' },
  ]);

  useEffect(() => {
    if (customers?.length) {
      setCustomersList(customers);
    }
  }, [customers]);

  useEffect(() => {
    if (suppliers?.length) {
      setSuppliersList(suppliers);
    }
  }, [suppliers]);

  return (
    <div className={cn.stepBlockWrapper} style={{ zIndex: 20 }}>
      <div className={cn.stepBlockContent}>
        <StepPartBlock title={applicationScheme?.suppliersTitle || 'Suppliers'}>
          {errors?.suppliers?.message && (
            <div className={cn.sumsubError}>{errors?.suppliers?.message}</div>
          )}
          {suppliersList?.map((item, index) => (
            <StepTwoValue
              key={`supplier-${item.id}-${item.monthlyTurnoverRangeId}`}
              value={item}
              setValue={setValue}
              values={suppliersList}
              setValuesList={setSuppliersList}
              type="suppliers"
              index={index}
              clearErrors={clearErrors}
              disabled={
                !isEditable ||
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
              }
              applicationScheme={applicationScheme}
            />
          ))}
          {isEditable &&
            status !== NewApplicationStatus.ACCEPTED &&
            status !== NewApplicationStatus.DECLINED && (
              <button
                type="button"
                className={cn.addProductButton}
                onClick={() => {
                  const nextSuppliers = ([] as StepTwoItemProps[]).concat(
                    suppliersList,
                  );

                  nextSuppliers.push({
                    id: `supplier-id-${(suppliersList?.length || 0) + 1}`,
                    name: '',
                    monthlyTurnoverRangeId: '',
                  });

                  setSuppliersList(nextSuppliers);
                }}
                tabIndex={-1}
              >
                <span>+</span> add{' '}
                {applicationScheme?.suppliersNameTitle || 'supplier'}
              </button>
            )}
        </StepPartBlock>
        <StepPartBlock title={applicationScheme?.customersTitle || 'Customers'}>
          {errors?.customers?.message && (
            <div className={cn.sumsubError}>{errors?.customers?.message}</div>
          )}
          {customersList?.map((item, index) => (
            <StepTwoValue
              key={`customer-${item.id}-${item.monthlyTurnoverRangeId}`}
              value={item}
              setValue={setValue}
              values={customersList}
              setValuesList={setCustomersList}
              type="customers"
              clearErrors={clearErrors}
              index={index}
              disabled={
                !isEditable ||
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
              }
              applicationScheme={applicationScheme}
            />
          ))}
          {isEditable &&
            status !== NewApplicationStatus.ACCEPTED &&
            status !== NewApplicationStatus.DECLINED && (
              <button
                type="button"
                className={cn.addProductButton}
                onClick={() => {
                  const nextCustomers = ([] as StepTwoItemProps[]).concat(
                    customersList,
                  );

                  nextCustomers.push({
                    id: `customer-id-${(suppliersList?.length || 0) + 1}`,
                    name: '',
                    monthlyTurnoverRangeId: '',
                  });

                  setCustomersList(nextCustomers);
                }}
                tabIndex={-1}
              >
                <span>+</span> add{' '}
                {applicationScheme?.customersNameTitle || 'customer'}
              </button>
            )}
        </StepPartBlock>
      </div>
    </div>
  );
};

export default NewApplicationCorporateInfoStepTwo;
